<template>
  <b-modal
    centered
    ref="modalApelido"
    title="Mudar Apelido"
  >
    <div class="form-group row">
      <div class="col-12">
        <label for="username-select">Informe um apelido <label v-if="conversation">para o(a) {{ conversation.name.nome }}</label>:</label>
        <b-form-input
          type="text"
          id="apelido-input"
          placeholder="Digite o apelido"
          v-model="nickname"
        ></b-form-input>
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100 text-right">
        <button
          type="button"
          class="btn btn-third btn-sm"
          v-on:click="onSetApelido"
          v-b-tooltip.hover
          :title="'Confirmar'"
        >
          <i class="fa fa-angle-double-right"></i
          ><span class="d-md-down-none"> Confirmar</span>
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { loading, toast } from '@/shared/utils/UIHelper'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento.js'

export default {
  name: 'ApelidoModal',
  data () {
    return {
      nickname: '',
      conversation: null
    }
  },
  methods: {
    async onSetApelido () {
      loading.push()

      if (!this.nickname || this.nickname.trim() === '') {
        toast.error('Por favor, informe um apelido válido.')
        loading.pop()
        return
      }

      try {
        const payload = {
          conversationId: this.conversation.conversationId,
          nickname: this.nickname
        }

        const response = await AtendimentoRepository.UpdateConversationNickname(payload)
        const { status } = response

        if (status === 200) {
          toast.success('Apelido atualizado com sucesso!')
          this.$emit('onUpdate')
        } else {
          toast.error('Não foi possível atualizar o apelido.')
        }
        this.$refs.modalApelido.hide()
      } catch (error) {
        console.error('Error setting nickname:', error)
        toast.error('Não foi possível atualizar o apelido.')
      } finally {
        loading.pop()
      }
    },
    show (conversation) {
      this.nickname = ''
      this.conversation = conversation

      if (conversation && conversation.name && conversation.name.apelido) {
        this.nickname = conversation.name.apelido
      }

      this.$refs.modalApelido.show()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/details/components/ApelidoModal.vue